export default "__VITE_ASSET__196be7d3__"